module.exports = __webpack_public_path__ + "static/img/feature_2.8c56bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/feature_2.png
// module id = 6kg2
// module chunks = 0